module.exports = __webpack_public_path__ + "static/media/L2.5379ce44.svg";